module.exports = __webpack_public_path__ + "img/pricing.5f7c72ba.webp";